import { lazyNamed } from 'src/utils/lazyNamed';

export const AdMedias = {
  List: lazyNamed(() => import('./containers/AdMediasList'), 'AdMediasList'),
  AdMediaHistory: lazyNamed(() => import('./containers/AdMediaHistory'), 'AdMediaHistory'),
};
